export const adminCore = {
  permissions: {
    noOptions: 'Нет вариантов',
    loadFailed: 'Не удалось загрузить permissions.',
    enterCode: 'Укажите code permission.',
    permissionSaved: (code: string) => `Permission ${code} сохранен.`,
    saveFailed: 'Не удалось сохранить permission.',
    selectAccount: 'Выберите аккаунт.',
    accountUpdated: 'Permissions аккаунта обновлены.',
    accountUpdateFailed: 'Не удалось обновить permissions аккаунта.',
    title: 'Права и роли',
    newRole: '+ Новая роль',
    permissionCode: 'Код permission',
    description: 'Описание',
    descriptionPlaceholder: 'Назначение permission, видно админам',
    saving: 'Сохраняю…',
    failurePrefix: 'Не удалось',
    searchPlaceholder: 'Имя или uid...',
    filterRole: 'Роль',
    filterPermission: 'Пермишен',
    onlyWithRoles: 'Только с ролями',
    withoutRoles: 'Без ролей',
    find: 'Найти',
    accounts: 'Аккаунты',
    refresh: 'Обновить',
    accountsNotFound: 'Аккаунты не найдены.',
    noName: 'Без имени',
    you: 'ты',
    assignShort: '+ Назначить',
    pagination: (page: number, totalPages: number, totalElements: number) =>
      `Стр. ${page} / ${totalPages} · ${totalElements} акк.`,
    next: 'Дальше',
    assignTitle: (name: string) => `Назначить: ${name}`,
    savingShort: '…',
    rolesAndPermissionsEmpty: 'Roles и permissions пока не созданы.',
    roles: 'Роли',
    permissions: 'Пермишены',
    noDescription: 'Без описания',
    rolesCatalog: 'Каталог ролей',
    activeRoles: (count: number) => `${count} активные роли`,
    roleFormTodoToast: 'TODO Phase 2: форма создания роли',
    addRoleShort: '+ роль',
    noRoles: 'Роли не созданы.',
    accountsShort: (count: number) => `${count} акк.`,
    permissionsCatalog: 'Каталог пермишенов',
    activePermissions: (count: number) => `${count} активных`,
    addPermissionShort: '+ перм',
    noPermissions: 'Пермишены не созданы.'
  },
  tags: {
    newTagName: 'Новый тег',
    loadFailed: 'Не удалось загрузить теги.',
    fillCodeAndName: 'Заполните code и name.',
    saving: 'Сохраняю тег...',
    saved: 'Тег сохранён.',
    saveFailed: 'Не удалось сохранить тег.',
    deleting: 'Удаляю тег...',
    deleted: 'Тег удалён.',
    deleteFailed: 'Не удалось удалить тег.',
    title: 'Теги игроков',
    createSubmit: 'Создать тег',
    searchPlaceholder: 'Поиск по названию или коду',
    searchAria: 'Поиск тегов',
    notFound: 'Ничего не найдено.',
    editAria: (name: string) => `Редактировать тег ${name}`,
    deleteAria: (name: string) => `Удалить тег ${name}`,
    newTag: '+ Новый тег',
    empty: 'Справочник тегов пуст.',
    edit: 'Править',
    expandAria: (name: string) => `Показать игроков с тегом ${name}`,
    collapseAria: (name: string) => `Скрыть игроков с тегом ${name}`,
    players: {
      title: 'Игроки с тегом',
      empty: 'Тег никому не назначен',
      loadFailed: 'Не удалось загрузить игроков.',
      loadMore: 'Показать ещё',
      removeTag: 'Снять тег',
      removeTagAria: (name: string) => `Снять тег с игрока ${name}`,
      removed: 'Тег снят.',
      removeFailed: 'Не удалось снять тег.',
      unknownNick: 'Без ника'
    },
    noTag: 'Без тега',
    noColor: 'Без цвета',
    deleteModal: {
      kicker: 'ДЕЙСТВИЕ',
      title: 'Подтвердить удаление',
      confirmPrefix: 'Удалить тег',
      confirmSuffix: '? Это действие необратимо.',
      confirmFallback: 'Удалить выбранный тег? Это действие необратимо.',
      submit: 'Удалить тег'
    },
    editor: {
      kicker: 'ТЕГ ИГРОКА',
      createTitle: 'Создание тега',
      editTitle: 'Редактирование тега',
      namePlaceholder: 'Администратор',
      codeLabel: 'Код',
      nameLabel: 'Название',
      iconLabel: 'Иконка',
      colorTitle: 'Цвет',
      noColorHint: 'Тег без цвета в игре показывается цветом по умолчанию.',
      legacyColorNote: 'Текущий цвет сохранён в старом формате. Если поменяете цвет, он будет заменён.',
      iconUpload: 'Загрузить картинку',
      iconUploading: 'Загрузка...',
      iconClear: 'Убрать иконку',
      iconPlaceholder: 'Текстовый alias или URL',
      iconHint: 'Для игры рекомендуется PNG: Panorama по http стабильно читает png/jpg.',
      iconUploadFailed: 'Не удалось загрузить картинку.',
      preview: 'Предпросмотр',
      gamePreview: 'Как в игре',
      gamePreviewHint: 'Карточка игрока в PvP-панели, 1:1 к 1080p.',
      previewPlayerName: 'Игрок',
      previewRank: (value: number) => `Ранг: ${value}`,
      previewMatches: (value: number) => `Матчи: ${value}`,
      previewAliasIcon: (alias: string) => `Иконка из игры: ${alias}`,
      saveChanges: 'Сохранить изменения'
    }
  },
  catalogs: {
    tabs: {
      heroes: 'NPC-герои',
      abilities: 'NPC-абилки',
      items: 'NPC-предметы'
    },
    title: 'Каталоги',
    warningPill: 'Изменения влияют на расчёт статистики',
    footerBanner: 'Правка справочника затрагивает текущие матчи и пересчёт публичных топов.',
    resources: {
      heroes: {
        entityLabel: 'героя',
        entryNoun: 'героев',
        kicker: 'Каталог героев',
        title: 'Доступные NPC-герои'
      },
      abilities: {
        entityLabel: 'способности',
        entryNoun: 'абилок',
        kicker: 'Каталог абилок',
        title: 'Доступные NPC-абилки'
      },
      items: {
        entryNoun: 'предметов',
        kicker: 'Каталог предметов',
        title: 'Доступные NPC-предметы'
      }
    },
    table: {
      displayName: 'Отображаемое имя',
      nameCode: 'Имя (код)',
      image: 'Картинка (URL / загрузка)',
      preview: 'Превью',
      searchByCodeOrName: 'Поиск по коду или имени',
      searchByName: 'Поиск по имени',
      deleteEntry: 'Удалить запись',
      deleteAria: (item: string) => `Удалить ${item}`,
      bulkHide: 'Скрыть импорт списком',
      bulkShow: 'Импорт списком',
      bulkPlaceholder: 'Каждая запись на новой строке.\nЗаменит текущий список после нажатия «Заменить».',
      bulkReplace: 'Заменить',
      copyCurrent: 'Скопировать текущий'
    },
    row: {
      resetDisplayTitle: 'Сбросить displayName',
      resetDisplayAria: 'Сбросить отображаемое имя',
      imagePlaceholder: 'URL картинки или /files/catalog/…',
      resetImageTitle: 'Сбросить imageUrl',
      resetImageAria: 'Сбросить URL картинки',
      upload: 'Загрузить картинку',
      uploadingAria: 'Загрузка...',
      noPreview: 'нет',
      renameTitle: 'Переименовать код',
      renameAria: (name: string) => `Переименовать код ${name}`,
      deleteRow: 'Удалить строку'
    },
    loadFailed: (kicker: string) => `Не удалось загрузить ${kicker.toLowerCase()}.`,
    renamed: (oldName: string, newName: string) => `Код переименован: ${oldName} → ${newName}`,
    renameFailed: 'Не удалось переименовать запись.',
    fileTooLarge: 'Файл слишком большой (макс. 5 МБ).',
    imageUploaded: 'Картинка загружена. Сохраните каталог, чтобы применить.',
    imageUploadFailed: 'Не удалось загрузить картинку.',
    saved: (kicker: string) => `${kicker} сохранен.`,
    saveFailed: (kicker: string) => `Не удалось сохранить ${kicker.toLowerCase()}.`,
    refresh: 'Обновить',
    revert: 'Отменить',
    noChanges: 'Нет изменений',
    saving: 'Сохраняю…',
    loading: 'Загружаю каталог…',
    nothingFound: 'Ничего не найдено по запросу.',
    emptyWithHint: 'Каталог пуст. Добавьте первую запись.',
    empty: 'Каталог пуст.',
    addEntry: '+ Добавить запись',
    addEntryPlaceholder: 'Добавить запись',
    emptyRowsNotSaved: 'Строки с пустым кодом не сохраняются.',
    totalEntries: 'Всего записей',
    abilitiesListTitle: 'Список доступных NPC-абилок',
    failurePrefix: 'не удалось',
    rename: {
      kicker: 'Каталог',
      title: (entityLabel: string) => `Переименовать код ${entityLabel}`,
      hintPrefix: 'Операция',
      hintStrong: 'атомарно переписывает историю',
      hintSuffix:
        ': код меняется в каталоге, матчах, банах и пресетах. Статистика сохранится под новым кодом. Действие необратимо.',
      currentCode: 'Текущий код',
      newCode: 'Новый код',
      sameCode: 'Новый код совпадает с текущим.',
      saving: 'Переименовываю…',
      submit: 'Переименовать'
    }
  }
};
